<template>
  <div class="tw-px-4 tw-pt-2 tw-pb-6">
    <SfBannerInline
      variant="info"
      :is-full-width="true"
      class="tw-w-full tw-justify-start"
      align="start"
    >
      <template #title>
        <strong>{{ checks.length }}</strong>
        {{ checksNotVisible }}
        <SfDropdown
          v-if="checklists.length > 1"
          dropdown-id="checks_not_visible"
          variant="seamless"
          drawer-direction="left"
        >
          <template #trigger>
            <span class="tw-text-sf-primary-dark tw-cursor-pointe">
              {{ checklistsText }}
            </span>
          </template>
          <template #menu>
            <SfDropdownItem
              v-for="checklist in checklists"
              :key="checklist.id"
              :href="getChecklistUrl(checklist)"
            >
              {{ checklist.name }} ({{ getCheckCountForChecklist(checklist) }})
            </SfDropdownItem>
          </template>
        </SfDropdown>
        <a
          v-else
          :href="getChecklistUrl(checklists[0])"
          class="tw-cursor-pointer"
          @click.stop
          >{{ checklists[0].name }}
        </a>
        {{ checksNotListed }}
      </template>
    </SfBannerInline>
  </div>
</template>

<script setup lang="ts">
import SfBannerInline from '@app/shared/vue/components/sf-banner/sf-banner-inline.vue'
import SfDropdown from '@app/shared/vue/connected/sf-dropdown.vue'
import SfDropdownItem from '@app/shared/vue/components/sf-dropdown/sf-dropdown-item.vue'
import { computed } from 'vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import type { Check, Checklist } from '../types'

const I18n = useI18n()

defineOptions({
  name: 'ChecksNotVisibleBanner',
})

interface Props {
  checks: Check[]
  checklists: Checklist[]
  workflowId: number
}
const props = defineProps<Props>()

const checksNotVisible = computed(() =>
  props.checks.length === 1
    ? I18n.t('company_workflows.checks_not_visible.one')
    : I18n.t('company_workflows.checks_not_visible.other')
)

const checklistsText = computed(() =>
  props.checklists.length === 1
    ? props.checklists[0].name
    : I18n.t('company_workflows.checklists', {
        count: props.checklists.length,
      })
)

const checksNotListed = computed(() =>
  props.checks.length === 1
    ? I18n.t('company_workflows.checks_not_listed.one')
    : I18n.t('company_workflows.checks_not_listed.other')
)

function getChecklistUrl(checklist: Checklist): string {
  return window.Silverfin.Routes.ledger_company_workflow_ledger_check_list_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    window.Silverfin.currentLedgerId(),
    props.workflowId,
    checklist.ledgerCheckListId
  )
}

function getCheckCountForChecklist(checklist: Checklist) {
  return props.checks.filter(
    (check) => check.ledgerCheckListId === checklist.ledgerCheckListId
  ).length
}
</script>
